import React from 'react';

import useProducts from 'b2b-ui-components-lib/lib/hooks/useProducts';
import usePartyAccounts from 'b2b-ui-components-lib/lib/hooks/usePartyAccounts';
import PostLoginSidebar from 'b2b-ui-components-lib/lib/components/postLoginSidebar';
import { getFromSessionStorage } from 'common/utils/app.utils';
import { MODULE_ID, PROFILE_DATA } from 'home/common/constants/constants';

const AppSidebar = (props) => {
  const { lobs, lobDetails, partnerProducts } = useProducts();
  const profile = getFromSessionStorage(MODULE_ID, PROFILE_DATA);
  const { partyDetails } = usePartyAccounts();
  const { isAuthJourney } = props;
  return (
    <React.Fragment>
      {isAuthJourney ? (
        <PostLoginSidebar lobs={lobs} partnerProducts={partnerProducts} lobDetails={lobDetails} partyDetails={partyDetails} isInternalUser={profile?.isInternalUser} />
      ) : (
        ''
      )}
    </React.Fragment>
  );
};

export default AppSidebar;
